import config from 'devextreme/core/config';

const licenseKey = "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjc5OTBhNTQ1LTNjNTEtNDgxMy04MmJmLTg3Y2ExZWU2MjA5NyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.V0fFKQr5Eh7hRwEWHTlbX8GSxVjnNVnAmK/hyO0XYn0L2SL8zUCXkFejt+T5lThjLXLh0uW+yT4oCjiSvHS5+t5VQZiGyoSxt3objNl1hlPjLGy4BrHF+kedSwUZH3ZALS453A==";

config({ licenseKey });